(() => {
  /*============================================================================
    Product template
  ==============================================================================*/
  var QuickAdd = (function () {
    var container;
    var sectionType;

    function QuickAdd(element) {
      container = element;
      _classCallCheck(this, QuickAdd);
      sectionType = container.dataset.sectionType;



      _initThumbCarousel();
      _attachListeners();
      scrollToModalTop();

    }

    function _initThumbCarousel() {
      const windowWidth =
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth;
      const isMobile = windowWidth < theme.sizes.small;
      let checked = container.querySelector(
        'input[name="options[Color]"]:checked'
      );


      if (checked) {
        checked = checked.value.toLowerCase().replaceAll(" ", "-");
      }

      const groupId = container.querySelector(
        '.product-form input[name="productId"]'
      )?.value;

      if (!groupId) {
        return;
      }

      showVariantImages(container, checked, groupId);
    }

    function scrollToModalTop() {
      const modalContentElement = container.querySelector('.product__scrollbar-sticky');
      if (modalContentElement) {
        // Set its scrollTop property to 0 to scroll to the top
        modalContentElement.scrollTop = 0;
        console.log('Modal content scrolled to top.');
      } else {
        console.warn('Modal content element (.product-quick-add__content) not found.');
      }
    }


    function showVariantImages(elem, value, productId) {
      let hasNoColor = container.querySelector('.product-quick-add__form').classList.contains("product--no-color")
      if (hasNoColor !== true) {
        let thumbs = elem.querySelectorAll(".thumb");
        if (thumbs) {
          thumbs.forEach((thumb) => {
            thumb.classList.add("hidden");
            var link = thumb.querySelector(".thumb__link");
            var alt = thumb.querySelector("img").getAttribute("alt");
            var groupId = link.dataset.groupId;

            if (alt) {
              alt = alt.toLowerCase().replaceAll(" ", "-");
              if (alt.includes(value) && groupId == productId) {
                thumb.classList.remove("hidden");
              }
            }
          });
          elem.querySelector(".thumb:not(.hidden) .thumb__link")?.click();
        }

        // hide all the images when layout is stacked
        let slides = elem.querySelectorAll(".product__slide");
        if (slides) {
          slides.forEach((slide) => {
            slide.classList.add("hidden");
            var option = slide.dataset.option;
            var groupId = slide.dataset.groupId;

            if (option) {
              option = option.toLowerCase().replaceAll(" ", "-");
              if (option.includes(value) && groupId == productId) {
                slide.classList.remove("hidden");
                slide.classList.remove("product__slide--non-critical");
              }
            }
          });
        }
      } else {
        elem.querySelectorAll(".product__slide").forEach((slide) => {
          slide.classList.remove("hidden");
          slide.classList.remove("product__slide--non-critical");
        });
      }
    }

    function variantSelected() {
      const selected = this;
      const selectedPosition =
        selected.closest(".selector-wrapper").dataset.selectPosition;
      const productForm = selected.closest("form");
      const productId = productForm.querySelector(
        'input[name="productId"]'
      ).value;
    
      if (selected.getAttribute("name") == "options[Color]") {
        let value = selected.value.toLowerCase().replaceAll(" ", "-");

        // let elem = document.querySelector('.thumbs-holder');
        // showVariantImages(elem, value, productId);
        const windowWidth =
          window.innerWidth ||
          document.documentElement.clientWidth ||
          document.body.clientWidth;
        const isMobile = windowWidth < theme.sizes.small;

        if (isMobile && container.getAttribute("data-tall-layout") !== "true") {
          let thumbsHolder = container.querySelector("[data-product-thumbs]");
          if (thumbsHolder) {
            let elem = document.querySelector(".thumbs-holder");
            showVariantImages(elem, value, productId);
          }
        } else {
          showVariantImages(container, value, productId);
          scrollToModalTop();
        }
      }
    }

    

    function _attachListeners() {
      container.querySelectorAll('.product__selectors input[type="radio"]:not(.optional-product__radio)')
        .forEach((radio) => {
          radio.addEventListener("change", variantSelected);
        });

    }

    _createClass(QuickAdd, [
      {
        key: "onUnload",
        value: function onUnload() { },
      },
    ]);

    return QuickAdd;
  })();

  window.QuickAdd = QuickAdd;

})();

